import React from 'react';

const About: React.FC = () => (
  <div className="about-page">
    
    <h2>5k Information</h2><p><p>
      Race Day Registration 7:30-8:50 am @ Stoddard Park
    </p>
    <p>
      This is a <strong>GREAT</strong> first time or beginner triathlon or 5k, while still being competitive for those mad skilled veterans!
    </p></p>
    
    
  </div>
);

export default About;